import '@/components/inject';
import { Locales, microRewriteBeforeEach } from '@/components/mambas';
import lodash from 'lodash';
import queryString from 'query-string';
import { link } from './extension/index';
import { $AppConfig } from './global';
import './microApp';
import { Store } from './store';
export * from './extension';
export * from './global';
export * from './mamba';
export * from './pages';
export * from './prototype';
export default async (ctx) => {
    onPlatform(ctx);
    // 解决 微应用模式下 keepAlive 路由会改变
    microRewriteBeforeEach(ctx);
    ctx.app.head = () => {
        return {
            titleTemplate: (title) => {
                if ($AppConfig.ChildrenPage)
                    return;
                return title;
            },
        };
    };
    if ($AppConfig.isManage) {
        await ParseToken(ctx);
    }
    lodash.set(ctx, '$Store', Store);
    lodash.set(ctx, 'AppConfig', $AppConfig);
    Locales.inject(ctx);
    // await Store.System.Auth.HydrateAsync;
    // 用户校验
    Store.System.onVerify();
};
function onPlatform(ctx) {
    if ($AppConfig.userAgent.isMobile &&
        !$AppConfig.development &&
        !$AppConfig.ChildrenPage) {
        const url = queryString.stringifyUrl({
            url: link.mobile,
            query: ctx.route.query,
        });
        window.location.replace(url);
        return;
    }
}
async function ParseToken(context) {
    let query = lodash.cloneDeep(context.query);
    await Store.System.onParseQueryToken(getParseToken(query));
}
function getParseToken(query) {
    const token = lodash.find([getAdminToken()], lodash.identity);
    if (token) {
        query = lodash.assign(query, { token });
    }
    return query;
}
function getAdminToken() {
    try {
        return sessionStorage.getItem('token');
    }
    catch (error) { }
}
